"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.isSummableMeasure = exports.CPA_COLUMN_TYPES = void 0;
const dbTableCampaign_1 = require("../../reporterDb/dbTableCampaign");
const columnTypes_1 = require("./columnTypes");
const isSalesCheck_1 = require("./isSalesCheck");
exports.CPA_COLUMN_TYPES = [
    columnTypes_1.ColumnTypes.AppMeasureCPA,
    columnTypes_1.ColumnTypes.AppMeasureCPAV2,
    columnTypes_1.ColumnTypes.CohortedAppMeasureCPA,
    columnTypes_1.ColumnTypes.DimensionAsMeasureCPA,
    columnTypes_1.ColumnTypes.DimensionAsMeasurePCPA,
];
//these live in METRICS_LABELED but are plain counts, not ratios, so they add up
const SUMMABLE_METRICS = [
    dbTableCampaign_1.Metrics.skanCTInstalls,
    dbTableCampaign_1.Metrics.skanVTInstalls,
    dbTableCampaign_1.Metrics.skanFirstTimeDownload,
];
/**
 * Whether a measure's value is a plain additive number.
 * Ratios (metrics, CPAs) are not: they come back as NaN when there is nothing
 * to divide, and their totals have to be recalculated rather than summed.
 * Single source of truth for the query's "row has data" check, subtotal/total
 * calculation in ReportNormalizer, and the agent's sum-vs-avg choice.
 */
const isSummableMeasure = (column) => {
    if (SUMMABLE_METRICS.includes(column.id))
        return true;
    if (dbTableCampaign_1.METRICS_LABELED[column.id])
        return false;
    if (column.columnType && exports.CPA_COLUMN_TYPES.includes(column.columnType)) {
        return false;
    }
    if ((0, isSalesCheck_1.isSalesRelatedMeasureCPA)(column))
        return false;
    const eventId = column.eventId;
    return !(eventId && dbTableCampaign_1.METRICS_LABELED[eventId]);
};
exports.isSummableMeasure = isSummableMeasure;
